<template>
  <div :class="`m-portal m-portal-${routeType}-single ${currentModule}`">
    <portal-nav-top></portal-nav-top>
    <div id="ljh-culture">
      <div class="container-fluid" style="width:1100px;">
        <el-row :gutter="20">
          <el-col :span="6" class="left-menu-wrap">
            <portal-cult-nav></portal-cult-nav>
          </el-col>
          <el-col :span="18" class="content-page-wrap">
            <div class="content-page" style="position:relative;">
              <div class="navigation">
                <span>首页</span>
                <span>&nbsp;>&nbsp;</span>
                <span>文化概述</span>
                <span>&nbsp;>&nbsp;</span>
                <span>{{title[$route.params._field]}}</span>
              </div>
              <div class="article">
                <bs-detail :filter="filter" :meta="meta" ref="refId" content-class>
                  <template slot="data" slot-scope="slot">
                    <portal-arti-single-zzzg
                      v-if="['zzzg'].indexOf($route.params._field)>-1"
                      style="line-height:21px;letter-spacing:2px;"
                      :result="slot"
                    ></portal-arti-single-zzzg>
                    <portal-arti-single-novideo
                      v-if="['lxcb'].indexOf($route.params._field)>-1"
                      :result="slot"
                    ></portal-arti-single-novideo>
                  </template>
                  <template slot="empty">空数据</template>
                </bs-detail>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <portal-footer></portal-footer>
    </div>
  </div>
</template>
<style lange="sass" scoped>
</style>
<script>
require("../../styles/portal/culture.scss");
export default {
  data() {
    return {
      title: {
        "zzzg":"朱子之歌",
        "lxcb":"理学传播",
      },
      routeType: "arti",
      video: false,
      novideo: true,
      meta: {
        module: this.$route.params._module,
        field: this.$route.params._field
      },
      filter: {
        artiId: this.$route.params._artiId
      },
      api: null
    };
  },
  props: {
    routeWatch: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    if (this.meta.field == "zzzg") {
      this.video = true;
      this.novideo = false;
    }
  },
  components: {
    BsDetail: () => import("../../components/bs-detail"),
    PortalNavTop: () => import("./portal-nav-top"),
    PortalCultNav: () => import("./portal-cult-nav"),
    PortalNavLeft: () => import("./portal-nav-left"),
    PortalArtiSingleNovideo: () => import("./portal-arti-single-novideo"),
    PortalArtiSingleZzzg: () => import("./portal-arti-single-zzzg"),
    PortalFooter: () => import("./portal-footer")
  },
  methods: {
  },
  computed: {
    currentModule() {
      return `${this.$route.params._module}_${this.$route.params._field}`;
    }
  },
  created() {
    this.$menuFn.setTitle(this.title[this.$route.params._field]+"-朱子文化·综合信息服务平台");
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "portal-arti-single") {
        this.$menuFn.setTitle(this.title[this.$route.params._field]+"-朱子文化·综合信息服务平台");
      }
      let contains = this.$loadRouteData(
        from,
        to,
        this.routeType,
        "single",
        "portal",
        false
      );
      if (this.routeWatch && contains) {
        this.$refs["refId"].clearData();
        this.meta.module = this.$route.params._module;
        this.meta.field = this.$route.params._field;
        this.$refs["refId"].loadData();
      }
    }
  }
};
</script>